<template>
  <main role="main">
    <public-banner class="banner" />
    <section class="contact-us">
      <h2 v-t>Contact Us</h2>
      <span v-t>Have some questions? Contact one of our regional representatives.</span>
    </section>
    <section>
      <ul class="regions">
        <li class="region">
          <h3 v-t>British Columbia</h3>
          <hr>
          <div class="contact">
            <span class="contact-name">John Pavlakis, CFP</span>
            <span v-t class="contact-title">Director of Business Development, Wealth - British Columbia</span>
            <div class="contact-details">
              <a href="mailto: jpavlakis@ppi.ca">jpavlakis@ppi.ca</a>
              <a href="tel: 604-657-7447">604-657-7447</a>
            </div>
          </div>
        </li>
        <li class="region">
          <h3 v-t>Ontario</h3>
          <hr>
          <div class="contact">
            <span class="contact-name">Mark Pahwa, MBA</span>
            <span v-t class="contact-title">Director of Business Development, Wealth - Ontario</span>
            <div class="contact-details">
              <a href="mailto: mpahwa@ppi.ca">mpahwa@ppi.ca</a>
              <a href="tel: 416-417-7412">416-417-7412</a>
            </div>
          </div>
        </li>
        <li class="region">
          <h3 v-t>Prairies</h3>
          <hr>
          <div class="contact">
            <span class="contact-name">Asad Zaidi, CIFC</span>
            <span v-t class="contact-title">Director of Business Development, Wealth - Prairies</span>
            <div class="contact-details">
              <a href="mailto: azaidi@ppi.ca">azaidi@ppi.ca</a>
              <a href="tel: 403-910-3357">403-910-3357</a>
            </div>
          </div>
        </li>
        <li class="region">
          <h3 v-t>Atlantic</h3>
          <div class="contact">
            <hr>
            <span class="contact-name">Ryan Stewart</span>
            <span v-t class="contact-title">Director of Business Development, Wealth - Atlantic</span>
            <div class="contact-details">
              <a href="mailto: rstewart@ppi.ca">rstewart@ppi.ca</a>
              <a href="tel: 902-233-1923">902-233-1923</a>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <public-footer />
  </main>
</template>

<script>
import { publicBanner, publicFooter } from '@/components/layout';

export default {
  head() {
    return {
      title: this.$t('Contact us'),
    };
  },

  components: {
    publicBanner,
    publicFooter,
  },
};
</script>

<style scoped lang="scss">


  main {
    background-color: $primary-50;

    section {
      background-color: $white;
    }
  }

  .banner {
    border-bottom: 1px solid $pearl-300;
  }

  .contact-us {
    padding: 3rem 1rem;
    text-align: center;
  }

  .regions {
    padding: 0 1rem;
    background-color: $white;

    @media #{$screen-width-small} {
      width: 80%;
      max-width: 55rem;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin: 0 auto;
    }

    @media all and (-ms-high-contrast: none) {
      display: block;
    }
  }

  .region {
    padding-bottom: 3rem;

    hr {
      margin: 0.75rem 0;
    }

    @media #{$screen-width-small} {
      display: inline-block;
      width: 48%;
      margin: 0 1%;
    }

    @media #{$screen-width-medium} {
      width: 31%;
    }

    @media all and (-ms-high-contrast: none) {
      display: block;
      width: 100%;
    }
  }

  .contact {
    span, a {
      display: block;
    }

    .contact-name {
      font-weight: bold;
    }

    .contact-title {
      margin-top: 0.25rem;
    }

    .contact-details {
      margin-top: 0.25rem;

      a {
        line-height: 1.5rem;
      }
    }
  }

</style>
